import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { angelopolisApi } from "../../api/angelopolisAPi";
import model from "../../assets/models/Calles.glb";

export class GlbCalles extends Mesh {
  constructor(loadingManager) {
    super();
    let loader = new GLTFLoader(loadingManager);
    let dracoloader = new DRACOLoader();

    dracoloader.setDecoderPath(
      "https://www.gstatic.com/draco/versioned/decoders/1.5.5/"
    );
    this.loading = loader;
    this.angelApi = new angelopolisApi();
    loader.setDRACOLoader(dracoloader);
    this.onLoadModel(loader);
    this.scale.set(1, 1, 1);
    this.position.set(120, -8, -290);
    // this.rotation.y += 0.03;
  }

  // "Z_nuevaZona1""Priv_santa_monica4"
  onLoadModel(loader) {
    loader.load(model, (gltf) => {
      this.add(gltf.scene);
      this.Arcadia = gltf.scene.getObjectByName("Arcadia002");
      this.Bali = gltf.scene.getObjectByName("Bali002");
      this.Capri = gltf.scene.getObjectByName("Capri002");
      this.Creta = gltf.scene.getObjectByName("Creta002");
      this.Fontana = gltf.scene.getObjectByName("Fontana002");
      this.Galena = gltf.scene.getObjectByName("Galena002");
      this.LaCantera = gltf.scene.getObjectByName("LaCantera002");
      this.Lucerna = gltf.scene.getObjectByName("Lucerna002");
      this.Rinconada = gltf.scene.getObjectByName("Rinconada002");
      this.Rodas = gltf.scene.getObjectByName("Rodas002");
      this.Sacramento = gltf.scene.getObjectByName("Sacramento002");
      this.Vilansa = gltf.scene.getObjectByName("Vilansa002");
      this.Balcanes = gltf.scene.getObjectByName("Balcanes002");
      // this.Palermo = gltf.scene.getObjectByName("Palermo");
      // this.Parque_berna = gltf.scene.getObjectByName("Parque_berna");
      // this.ParqueViena = gltf.scene.getObjectByName("ParqueViena");
      // this.Sofia = gltf.scene.getObjectByName("Sofia");
      // this.Anturio = gltf.scene.getObjectByName("Anturio");

      this.validateandModificateClusters();
    });
  }
  validateandModificateClusters() {
    const uiElements = [
      {
        father: this.menuZoneOne,
        childrens: [
          {
            //fontana
            meshElement: this.Fontana,
            slug: "A-110 B",
          },
          {
            //sacramento
            meshElement: this.Sacramento,
            slug: "A-110A",
          },
          {
            //arcadia
            meshElement: this.Arcadia,
            slug: "A-108 B",
          },
          {
            //rinconada
            meshElement: this.Rinconada,
            slug: "A-106",
          },
          {
            //galena
            meshElement: this.Galena,
            slug: "A108A/A109",
          },
        ],
      },
      {
        father: this.menuZoneTwo,
        childrens: [
          {
            //capri
            meshElement: this.Capri,
            slug: "*************",
          },
          {
            //creta
            meshElement: this.Creta,
            slug: "A-91",
          },
          {
            //rodas
            meshElement: this.Rodas,
            slug: "*************",
          },
          {
            //bali
            meshElement: this.Bali,
            slug: "D-67AB/D70",
          },
        ],
      },

      {
        father: this.menuZoneSeven,
        childrens: [
          {
            //lucerna
            meshElement: this.Lucerna,
            slug: "C-30",
          },
          {
            //cantera
            meshElement: this.LaCantera,
            slug: "D-28",
          },
        ],
      },

      {
        father: this.menuZoneThree,
        childrens: [
          {
            //vilansa
            meshElement: this.Vilansa,
            slug: "A-176",
          },
        ],
      },
      {
        father: this.menuZoneSix,
        childrens: [
          {
            //balcanes
            meshElement: this.Balcanes,
            slug: "C3",
          },
        ],
      },
      // {
      //   father: this.menuZoneFive,
      //   childrens: [
      //     // {
      //     //   //parque viena
      //     //   meshElement: this.ParqueViena,
      //     //   slug: "*************",
      //     // },
      //     // {
      //     //   //parque berna
      //     //   meshElement: this.Parque_berna,
      //     //   slug: "*************",
      //     // },
      //     // {
      //     //   //palermo
      //     //   meshElement: this.Palermo,
      //     //   slug: "A-9F1",
      //     // },
      //     // {
      //     //   //sofia
      //     //   meshElement: this.Sofia,
      //     //   slug: "A-9D",
      //     // },
      //   ],
      // },

      // {
      //   father: this.meshElement,
      //   childrens: [
      //     {
      //       //anturio
      //       meshElement: this.Anturio,
      //       slug: "ANTURIO",
      //     },
      //   ],
      // },
    ];
    uiElements.forEach((element) => {
      const hiddenChildren = element.childrens.filter(
        (children) =>
          children.slug === "*************" ||
          this.angelApi.clusters.some(
            (clus) => clus.slug === children.slug && !clus.isOpend
          )
      );
      if (hiddenChildren.length === 0) return;
      hiddenChildren.forEach((children) => {
        if (children.meshElement) {
          children.meshElement.visible = false;
        }
      });
    });
  }

  renderAnimations() {}
}
